module.exports = __webpack_public_path__ + "img/2021_NCB.494e4058.png";